/**
 * Special characters per pwc-22399
 */
export const specialChars = [
  '!',
  '"',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  '|',
  ')',
  `'`,
  '\\',
  '/',
  '{',
  '}',
  '-',
  '_',
  '=',
  '+',
  '.',
  ',',
  ';',
  ':',
  '<',
  '>',
  '?',
  '[',
  ']',
  '`',
  '~',
];
